export default import.meta.ROLLUP_FILE_URL_XZfAfMcodrPz3zh$rQMF$A